import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaReact,
  FaGithub,
} from "react-icons/fa";
import { SiTailwindcss, SiFigma, SiNextdotjs } from "react-icons/si";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["Professional Coder.", "Full Stack Developer.", "Mobile App Developer.", "Website Developer.", "Project Manager.", "UI Designer as well.",  ],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 3000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h2 className=" text-lg font-normal">My world is a place of endless possibility, where imagination knows no bounds!</h2>
        <h1 className="text-6xl font-bold text-white">
          Hi, I'm <span className="text-designColor capitalize">Asma Jalal</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          A <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#07f808"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
        I’m a Full-Stack Mobile and Web developer skilled in React Native, 
        React JS, Next JS, Node JS, AWS, MongoDB, Firebase, and PostgreSQL. 
        As a dedicated Full Stack React Native Developer with 5+ years of experience, 
        I specialize in building high-performance crossplatform mobile apps.
        with smooth state management with Redux and Zustand, and integrating RESTfulAPIs for dynamic, scalable apps. I’m passionate about 
         mobile performance optimization and writing clean, maintainable code. 
         collaboration with a dedicated team of developers and designers. 
         Together, we’ve delivered diverse projects across industries like E-commerce, 
         Sports, ERP Solutions, Fashion, ChatGPT, Social Media, Food Delivery, and many more.
        </p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me in
          </h2>
          <div className="flex gap-4">
            <a href="https://github.com/AsmaJalal" target="blank">
              <span className="bannerIcon">
                <FaGithub />
              </span>
            </a>
            <a href="https://github.com/AsmaJalal/asma-portfolio" target="blank">
              <span className="bannerIcon">
                <FaFacebookF />
              </span>
            </a>
            <a href="https://github.com/AsmaJalal" target="blank">
              <span className="bannerIcon">
                <FaTwitter />
              </span>
            </a>
            <a href="https://github.com/AsmaJalal" target="blank">
              <span className="bannerIcon">
                <FaLinkedinIn />
              </span>
            </a>
          </div>
        </div>
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
          <a href="https://react.dev/" target="blank">
            <span className="bannerIcon">
              <FaReact />
            </span>
            </a>
            <a href="https://nextjs.org/" target="blank">
            <span className="bannerIcon">
              <SiNextdotjs />
            </span>
            </a>
            <a href="https://tailwindcss.com" target="blank">
            <span className="bannerIcon">
              <SiTailwindcss />
            </span>
            </a>
            <a href="https://www.figma.com/" target="blank">
            <span className="bannerIcon">
              <SiFigma />
            </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftBanner;
